window.customRadioKeyboardNav = function(container) {
  const colorButtons = container.querySelectorAll('.js-color-label');

  container.addEventListener('keydown', function (e) {
    const current = e.target.closest('.js-color-label[aria-checked="true"]');
    if (!current) return;

    switch (e.key) {
      case 'ArrowUp':
      case 'ArrowLeft':
        e.preventDefault();
        selectPrevious(current);
        break;

      case 'ArrowDown':
      case 'ArrowRight':
        e.preventDefault();
        selectNext(current);
        break;

      case ' ':
      case 'Enter':
        e.preventDefault();
        selectColor(current);
        break;
    }
  });

  function selectPrevious(current) {
    const index = Array.from(colorButtons).indexOf(current);
    const prev = index > 0 ? colorButtons[index - 1] : colorButtons[colorButtons.length - 1];
    selectColor(prev);
  }

  function selectNext(current) {
    const index = Array.from(colorButtons).indexOf(current);
    const next = index < colorButtons.length - 1 ? colorButtons[index + 1] : colorButtons[0];
    selectColor(next);
  }

  function selectColor(colorButton) {
    colorButtons.forEach((btn) => {
      btn.setAttribute('tabindex', '-1');
      btn.setAttribute('aria-checked', 'false');
    });

    colorButton.setAttribute('tabindex', '0');
    colorButton.setAttribute('aria-checked', 'true');

      colorButton.focus();

    const input = document.getElementById(colorButton.getAttribute('for'));
    if (input) {
      input.checked = true;

      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}

if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        const colorContainer = this.querySelector('.product-form__input--color');
        if (colorContainer) window.customRadioKeyboardNav(colorContainer);
        this.addEventListener('change', (event) => {
          this.updateAddToCartButton(event.target,event);
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event,this);
          this.updateCustomCounter(event.target);
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        });

        this.addEventListener('keydown', (e) => {
          const target = e.target.closest('label[role="radio"]');
          if (!target) return;

          if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault(); 
            const input = document.getElementById(target.getAttribute('for'));
            if (input) {
              input.checked = true;
              input.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        })
      }
      updateAddToCartButton(ele) {
        const productCard = ele.closest(".product-card__info.text-left"); 
          if (!productCard) return; 
          const addToCartButton = productCard.querySelector(".custom-form");
          if (!addToCartButton) {
              //console.log("No .custom-form found inside product card.");
              return;
          }
          const variantInput = addToCartButton.querySelector("input.product-variant-id"); 
          //console.log(variantInput);
          if (!variantInput) {
              //console.log("No input with class .product-variant-id found inside .custom-form.");
              return;
          }
          variantInput.value = ele.getAttribute("variantid"); // Set the input value
          //console.log("Updated variant ID:", variantInput.value);
        // html chages
            let scriptElements = document.querySelectorAll(".js-replase-html");
            if (!scriptElements.length) return;
            
            // Variant ID to check (Replace with actual selected variant ID)
            let selectedVariantId = variantInput.value; 
            
            scriptElements.forEach(scriptElement => {
                let jsonData;
                
                try {
                    jsonData = JSON.parse(scriptElement.textContent.trim());
                    //console.log("Parsed JSON:", jsonData);
                } catch (error) {
                    console.error("Error parsing JSON:", error);
                    return;
                }
            
                // Check if the variant ID exists in the JSON data
                if (jsonData.hasOwnProperty(selectedVariantId)) {
                    let htmlContent = jsonData[selectedVariantId];
            
                    let cardWrapper = productCard?.closest(".product-card__wrapper");
                    if (cardWrapper) {
                        let motionElement = cardWrapper.querySelector("motion-element");
                        if (motionElement) {
                            motionElement.innerHTML = htmlContent;  // ✅ Fixed `innerHTML`
                            //console.log("Updated HTML Content for variant:", htmlContent);
                        } else {
                            // console.error("motion-element not found inside cardWrapper");
                        }
                    } else {
                        // console.error("cardWrapper not found for productCard");
                    }
                }
            });
      }


      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }

      updateCustomCounter(target) {
        let variantCount = target.getAttribute('data-custom-count');
        let customCountEle = document.querySelector('.js-custom-count');
        if (customCountEle) {
          if (variantCount) {
            let customCount = customCountEle.textContent;
            let newCount = customCount.replace(/\d+/, variantCount);
  
            customCountEle.classList.remove("hidden");
            customCountEle.textContent = newCount;
          } else {
            customCountEle.classList.add("hidden")
          }
        }
      }
    }
  );
}
